import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import CustomersPage from "@/pages/CustomersPage";
import DomainsPage from "@/pages/DomainsPage";
import AppsPage from "@/pages/AppsPage";
import CertificatesPage from "@/pages/CertificatesPage";
import MailPage from "@/pages/MailPage";
import CleanupPage from "@/pages/CleanupPage";
import AlertsPage from "@/pages/AlertsPage";
import ChangesPage from "@/pages/ChangesPage";
import ActionCenterPage from "@/pages/ActionCenterPage";
import CustomerDetailPage from "@/pages/CustomerDetailPage";
import ServerDetailPage from "@/pages/ServerDetailPage";
import { Layout } from "@/components/Layout";
import ArchitecturePage from './pages/ArchitecturePage';
import MailArchitecturePage from './pages/MailArchitecturePage';
import CustomersOverviewPage from '@/pages/CustomersOverviewPage';
import IncidentTimelinePage from '@/pages/IncidentTimelinePage';

const ProtectedRoute = ({ children }) => {
  const { token, loading } = useAuth();
  if (loading) return null;
  if (!token) return <Navigate to="/login" replace />;
  return children;
};

const PublicRoute = ({ children }) => {
  const { token, loading } = useAuth();
  if (loading) return null;
  if (token) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: 'hsl(240 5% 7%)',
              border: '1px solid hsl(240 4% 16%)',
              color: 'hsl(0 0% 98%)',
            },
          }}
        />
        <Routes>
          <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<DashboardPage />} />
            <Route path="customers" element={<CustomersPage />} />
            <Route path="customers/:customerId" element={<CustomerDetailPage />} />
            <Route path="domains" element={<DomainsPage />} />
            <Route path="certificates" element={<CertificatesPage />} />
            <Route path="mail" element={<MailPage />} />
            <Route path="cleanup" element={<CleanupPage />} />
            <Route path="alerts" element={<AlertsPage />} />
            <Route path="changes" element={<ChangesPage />} />
            <Route path="actions" element={<ActionCenterPage />} />
            <Route path="apps" element={<AppsPage />} />
            <Route path="customer-overview" element={<CustomersOverviewPage />} />
            <Route path="architecture" element={<ArchitecturePage />} />
            <Route path="mail-architecture" element={<MailArchitecturePage />} />
            <Route path="incident-timeline" element={<IncidentTimelinePage />} />
            <Route path="servers/:assetId" element={<ServerDetailPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
